module.exports = __webpack_public_path__ + "static/media/fruehlingsbluete.2407c46c.jpg";